import { useRef } from "react";
import { ErrorBoundary } from "react-error-boundary";
import Routers from "./routes";
import "react-image-crop/dist/ReactCrop.css";
import "@xinosolutions/xs-shell/styles.css";
import "./assets/css/feed_style.css";
import "./assets/css/style.css";
import "./assets/css/ChooseDocument.css";
import "./assets/css/light-theme.css";
import "./assets/css/sidebar.css";
import "./assets/css/LinkPreviews.css";
import "./assets/css/portal-landing.css";
import "./assets/css/certificates.css";

import { ContentSetting } from "./Hooks/ContentSetting";
import { SnackbarProvider } from "notistack";
import { Button, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ThemeConfig from "./theme";
import { ThemeProvider } from "./contexts/ThemeContext";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback";
import AdminProviders from "./components/providers/AdminProviders";
import ProductWorkspaceSync from "./components/providers/ProductWorkspaceSync";

function App() {
  const notistackRef = useRef(null);

  const onClickDismiss = (key) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <ThemeProvider defaultTheme="dark">
          <ThemeConfig>
            <SnackbarProvider
              ref={notistackRef}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              TransitionComponent={Slide}
              maxSnack={3}
              action={(key) => (
                <Button
                  className="snackbar-cross-icon"
                  onClick={onClickDismiss(key)}
                >
                  <CloseIcon />
                </Button>
              )}
            >
              <AdminProviders>
                <ContentSetting>
                  <ProductWorkspaceSync />
                  <Routers />
                </ContentSetting>
              </AdminProviders>
            </SnackbarProvider>
          </ThemeConfig>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
